export const PUBLIC_BLOG_AUTHOR_NAME = "MOT Cards Team" as const;
